import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';

export const REVIEW_SIZE = {
  width: 494,
  height: {
    mobile: 234,
    desktop: 182,
  },
};

export const Wrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    width: ${REVIEW_SIZE.width}px;
  `}
  height: ${REVIEW_SIZE.height.desktop}px;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: ${REVIEW_SIZE.height.mobile}px;
  `}
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: ${({ theme }) => theme.spacing(3)};
  position: relative;
  background: ${({ theme }) => theme.colors.neutrals.white};
  filter: drop-shadow(1px 1px 4px ${({ theme }) => colorToAlpha(theme.colors.neutrals.black, 0.1)});
  &:after {
    position: absolute;
    content: '';
    top: 100%;
    right: 20px;
    border-top: 5px solid ${({ theme }) => theme.colors.neutrals.white};
    border-right: 10px solid ${({ theme }) => theme.colors.neutrals.white};
    border-bottom: 5px solid transparent;
    border-left: 10px solid transparent;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.brand.darker};
`;

export const Description = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WorkedWith = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;
